import type { Observable as ObservableType } from 'rxjs/Observable';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import type { UserPropertyKeys } from '../../view/whiteboards-entrypoint-experiment/constants.tsx';
import type { ConfluencePermissionsResponse, ConfluenceSpacesResponse } from './types.tsx';

export function fetchConfluencePermissions(): ObservableType<ConfluencePermissionsResponse> {
	return fetchJson$('/wiki/rest/api/user/current?expand=operations');
}

export function fetchConfluenceSpace(): ObservableType<ConfluenceSpacesResponse> {
	return fetchJson$('/wiki/api/v2/spaces?limit=1');
}

type SiteTAPTraitResponse = {
	attributes: {
		name: string;
		value: string;
	}[];
};

export function fetchSiteTraits(cloudId: string): ObservableType<SiteTAPTraitResponse> {
	return fetchJson$<SiteTAPTraitResponse>(
		`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`,
		{
			perf: {
				key: 'site-traits',
				prefix: 'whiteboards-entrypoint-experiment',
			},
		},
	);
}

export function fetchUserPropertyKeys(accountId: string): ObservableType<UserPropertyKeys> {
	return fetchJson$<UserPropertyKeys>(
		`/rest/api/3/user/properties?accountId=${encodeURIComponent(accountId)}`,
	);
}
